<div>
  <div class="login-form-cotainer  row">
    <div class="column small-12 medium-6 large-6 medium-centered">
      <div class="form">
        <header>
          <h4>Welcome, Please update your password.</h4>
        </header>
        <div class="row">
          <div class="small-12 columns ">
            <input type="password" placeholder="New Password *" [(ngModel)]="password">
          </div>
          <div class="small-12 columns ">
            <input type="password" placeholder="Confirm Password *" [(ngModel)]="confirmPassword">
          </div>
          <div *ngIf="notValid" class="small-12 columns" class="error" style="text-align: center">
            Password and confirm should match
          </div>
        </div>
        <div class="row align-middle">
          <div class="small-6 column">
            <button type="submit" class="button custom-login" (click)="submit($event)">UPDATE PASSWORD
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
